export const eventProperties = {
    language_landing: document.documentElement.lang,
    page_url: window.location.href,
};
